import CheckinScanner from "@/pages/CheckinScanner";
export default function PartyCheckin() {
  return <CheckinScanner kind="party" />;
}
